import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

interface IProps {
    className?: string;
    style?: any;
}

export const TextBlock: React.FunctionComponent<IProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 64 64" {...props}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g>
                    <rect x="0" y="0" width="64" height="64"></rect>
                    <line
                        x1="54"
                        y1="31.5"
                        x2="11"
                        y2="31.5"
                        stroke="currentColor"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></line>
                    <line
                        x1="54"
                        y1="42.5"
                        x2="11"
                        y2="42.5"
                        stroke="currentColor"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></line>
                    <line
                        x1="32"
                        y1="53.5"
                        x2="11"
                        y2="53.5"
                        id="Path-Copy"
                        stroke="currentColor"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></line>
                    <rect fill="currentColor" x="9" y="11" width="47" height="13" rx="2"></rect>
                </g>
            </g>
        </SvgIcon>
    );
};
